var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconElexityLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4788_6319)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F76100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8129 16.3149L11.5379 10.0046C11.4477 9.88988 11.2974 9.81818 11.1471 9.81818H6.78886C6.59348 9.81818 6.47326 10.0476 6.59348 10.1911L13.1309 17.9928L6.60851 25.8089C6.48828 25.9523 6.59348 26.1818 6.80388 26.1818H11.1622C11.3125 26.1818 11.4477 26.1101 11.5529 25.9954L16.8279 19.6851C17.6545 18.6956 17.6545 17.3044 16.8129 16.3149V16.3149ZM29.3768 25.8089L25.2439 20.8611C24.1318 19.5417 22.4486 18.7529 20.6752 18.7529H18.992C18.7366 18.7529 18.6013 19.0254 18.7516 19.2118L24.4173 25.9954C24.5075 26.1101 24.6578 26.1818 24.8081 26.1818H29.1664C29.4068 26.1818 29.512 25.9523 29.3768 25.8089V25.8089ZM29.2115 9.81818H24.8532C24.7029 9.81818 24.5676 9.88988 24.4624 10.0046L18.7967 16.7881C18.6464 16.9746 18.7816 17.2471 19.0371 17.2471H20.7203C22.4937 17.2471 24.1769 16.4583 25.289 15.1389L29.4219 10.1911C29.512 10.0333 29.4068 9.81818 29.2115 9.81818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4788_6319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElexityLogo);
export default __webpack_public_path__ + "static/media/icon_elexity_logo.966628163ee5f09d06790d8e9f2ee386.svg";
export { ForwardRef as ReactComponent };